import { render, staticRenderFns } from "./Profile.form.vue?vue&type=template&id=32727529&scoped=true&lang=pug&"
import script from "./Profile.form.vue?vue&type=script&lang=ts&"
export * from "./Profile.form.vue?vue&type=script&lang=ts&"
import style0 from "./Profile.form.vue?vue&type=style&index=0&id=32727529&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32727529",
  null
  
)

export default component.exports